export var AccountType;
(function (AccountType) {
    AccountType["USER"] = "user";
    AccountType["SYSTEM"] = "system";
    AccountType["MAINTENANCE"] = "maintenance";
})(AccountType || (AccountType = {}));
export var AccountStatuses;
(function (AccountStatuses) {
    AccountStatuses["ACTIVE"] = "ACTIVE";
    AccountStatuses["INACTIVE"] = "INACTIVE";
    AccountStatuses["SUSPENDED"] = "SUSPENDED";
    AccountStatuses["DELETED"] = "DELETED";
})(AccountStatuses || (AccountStatuses = {}));
//# sourceMappingURL=account.js.map